import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueApollo from 'vue-apollo'
import AWSAppSyncClient from 'aws-appsync'
import i18n from './i18n'
import Lottie from 'vue-lottie'
import Flag from 'vue-flagpack';
import {Amplify} from 'aws-amplify';
  
// Initialize AWS Amplify library
Amplify.configure({
  Auth: {
    region: 'us-east-1',             // Replace with your region
    userPoolId: 'us-east-1_LKpAkTLn2',     // Replace with your User Pool ID
    userPoolWebClientId: '3vr45vnntgtn2du4for24o5438',  // Replace with your App Client ID
  }
});

const config = {
  url: 'https://gxd52tpynfcjbghzu7axjnbbk4.appsync-api.us-east-1.amazonaws.com/graphql',
  region: 'us-east-1',
  auth: {
   type: 'AWS_LAMBDA',
   token: '1',
  },
  disableOffline: true // this was added to stop an issue with duplicated list items
 }

// The default fetchPolicy is cache-first. This means that if data
// is returned from the cache, no network request will be sent. If
// a new item is in a list, this will not be realised. So here we change
// the policy so that network requests are always sent after data is returned
// from the cache.
const options = {
 defaultOptions: {
  watchQuery: {
    fetchPolicy: 'cache-and-network'
  }
 }
}
const client = new AWSAppSyncClient(config, options)
const appsyncProvider = new VueApollo({
 defaultClient: client
})
Vue.use(VueApollo)
Vue.config.productionTip = false;
Vue.component('lottie', Lottie);
Vue.use(Flag, {name: 'Flag'});

new Vue({
 router,
 store,
 vuetify,
 render: h => h(App),
 i18n,
 apolloProvider: appsyncProvider
}).$mount('#app');
